import * as React from 'react';
import { PikCheckbox } from '../../../../ui/pik_checkbox/pik_checkbox';
import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../../../types/redux';
import { decorationChange } from '../../../../actions/filter';

interface IWithDesignFilterProps {
  decoration: boolean;
  setDecoration(value: boolean): void;
}

class WithDesign extends React.PureComponent<IWithDesignFilterProps, object> {
  public render() {
    return <PikCheckbox label="с отделкой" value={this.props.decoration} onValueChange={this.props.setDecoration} />;
  }
}

export const WithDesignField = connect(
  (state: IApplicationState) => ({
    decoration: state.filter.query.decoration,
  }),
  (dispatch: TTypedThunkDispatch) => {
    return {
      setDecoration: (value: boolean) => {
        dispatch(decorationChange(value));
      },
    };
  },
)(WithDesign);
